import { IClientGridRow } from '@/Interfaces/Client.interface';
import WhitelabelIcon from '@/components/Icons/WhitelabelIcon';
import { Chip, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const WhitelabelChip = styled(Chip)(({ theme }) => ({
  maxHeight: '29px',
  borderRadius: '32px',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: 12,
  '& .whitelabel-icon': {
    margin: '0 -8px -2px 10px',
    color: theme.palette.primary.dark,
    width: 13,
  },
}));

const WhitelabelCell = ({ value }: GridRenderCellParams<IClientGridRow>) => {
  return (
    <div className='overflow-hidden'>
      {value ? <WhitelabelChip icon={<WhitelabelIcon />} variant='outlined' label={value.label} /> : '-'}
    </div>
  );
};

export default WhitelabelCell;
